import Modal from './Modal';
import Button from './Button';

/**
 * Generic yes/no confirmation modal for actions with real consequences
 * (sign out, cancel subscription, revoke access, etc). `onConfirm` may be
 * async; the confirm button shows a spinner and the dialog stays open until
 * it resolves so a slow request can't be double-fired by an impatient click.
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {typeof description === 'string' ? (
        <p className="text-sm text-slate-600">{description}</p>
      ) : (
        description
      )}
    </Modal>
  );
}
